import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A React Hook
 * Uses search params to handle search queries
 * @returns 
 */
export default function useSearch(limit = null) {
    /* Search functionality */
    const [searchParams, setSearchParams] = useSearchParams();
    const searchQuery = useMemo(() => {
        const query = {};
        const entries = [...searchParams.entries()];
        for (const [k, v] of entries) {
            if (!(k in query)) {
                query[k] = v;
            } else {
                if (Array.isArray(query[k])) {
                    query[k].push(v);
                } else {
                    query[k] = [query[k], v];
                }
            }
        }
        return query;
    }, [searchParams]);
    const updateSearchParams = (newSearchQueryParams = {}) => {
        const result = {};
        let resetPage = false;
        let resetFilters = false;
        for (const [param, paramVal] of Object.entries(newSearchQueryParams)) {
            if (!paramVal)
                continue;
            result[param] = paramVal;
            if (param !== 'page') {
                if (typeof paramVal !== 'string'
                    || paramVal !== searchParams.get(param)) {
                    resetPage = true;
                    if (param === 'q') {
                        resetFilters = true;
                    }
                }
            }
        }
        if (resetPage === true) {
            result.page = 0;
        }
        if (resetFilters === true) {
            result.t = [];
            result.c = [];
            result.v = '';
        }
        setSearchParams(result);
    };
    return {
        searchQuery,
        updateSearchParams,
    };
}